// Replace url parameter
const replaceUrlParameter = function (url, paramName, paramValue) {
    if (paramValue == null) {
        paramValue = ``
    }
    const pattern = new RegExp(`\\b(${paramName}=).*?(&|$)`)
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, `$1${paramValue}$2`)
    }
    return `${url + (url.indexOf(`?`) > 0 ? `&` : `?`) + paramName}=${paramValue}`
}
// remove url parameter
const removeUrlParameter = function (url, paramName) {
    // Use this function incase we are not removing the url of the current page.
    let value = encodeURIComponent(getUrlParameterByName(paramName, url))
    // Add commers back in
    value = value.replace(`%2C`, `,`)

    const name = encodeURIComponent(paramName)
    let newUrl = ``

    if (url.indexOf(`?${name}=${value}`) > -1) {
        if (location.search.split(`&`).length > 1) {
            newUrl = url.replace(`${name}=`, ``).replace(`${value}&`, ``)
        } else {
            newUrl = url.replace(`?${name}=`, ``).replace(value, ``)
        }
    } else {
        newUrl = url.replace(`&${name}=`, ``).replace(value, ``)
    }
    return newUrl
}

const removeAttributeUrlParameter = function (url, paramName, attribute) {
    let params = getUrlParameterByName(paramName)
    params = params.split(`,`)
    const index = params.indexOf(attribute)
    if (index > -1) {
        params.splice(index, 1)
    }
    params = params.toString()
    params = encodeURIComponent(params)
    const newUrl = replaceUrlParameter(url, paramName, params)

    return newUrl
}
// Get url param
const getUrlParameters = function () {
    const parameters = {}
    if (location.search.length) {
        for (
            let value, i = 0, pairs = location.search.substr(1).split(`&`);
            i < pairs.length;
            i++
        ) {
            value = pairs[i].split(`=`)
            if (value.length > 1) {
                parameters[decodeURIComponent(value[0])] = decodeURIComponent(value[1])
            }
        }
    }
    return parameters
}
// Push a new url
const pushNewUrl = function (url, method = `push`) {
    if (method === `push`) {
        window.history.pushState({path: url}, ``, url)
    } else {
        window.history.replaceState({path: url}, ``, url)
    }
}
// Update the window location hash, and remove it entirely if needed
const updateHash = function (hash, method) {
    method = method || `push`

    if (hash == null || hash == undefined || hash == ``) {
        if (method == `push`) {
            window.history.pushState(
                ``,
                document.title,
                window.location.pathname + window.location.search
            )
        } else {
            window.history.replaceState(
                ``,
                document.title,
                window.location.pathname + window.location.search
            )
        }
    } else {
        if (method == `push`) {
            window.history.pushState(
                ``,
                document.title,
                window.location.pathname + `#` + hash + window.location.search
            )
        } else {
            window.history.replaceState(
                ``,
                document.title,
                window.location.pathname + `#` + hash + window.location.search
            )
        }
    }
}
// Collection template sorting
const getUrlParameterByName = function (parameter) {
    let url = decodeURIComponent(window.location.search.substring(1)),
        urlVariables = url.split(`&`),
        parameterName
    for (let i = 0; i < urlVariables.length; i += 1) {
        parameterName = urlVariables[i].split(`=`)
        if (parameterName[0] === parameter) {
            return parameterName[1] === undefined ? true : parameterName[1]
        }
    }
}


export {
    replaceUrlParameter,
    removeUrlParameter,
    getUrlParameters,
    pushNewUrl,
    updateHash,
    getUrlParameterByName,
    removeAttributeUrlParameter,
}
